module.exports = __webpack_public_path__ + "img/sumit_logo_1.41d91ba0.svg";